const DataDisplayTestIdsScope = {
  DATA_DISPLAY: 'data-display',
};

export const DataDisplayTestIds = {
  // DataDisplay
  DATE_RANGE_WRAPPER: `${DataDisplayTestIdsScope.DATA_DISPLAY}.date-range-wrapper`,
  TITLE_PANEL: `${DataDisplayTestIdsScope.DATA_DISPLAY}.title-panel`,

  // Dynamic
  getDataDisplayContentId: title => `${DataDisplayTestIdsScope.DATA_DISPLAY}.content-${title}`,
};
